import React, { memo } from 'react'
import { Handle, Position } from 'reactflow'
import useAct from 'Workflows/hooks/useAct'
import useNodeSize from 'Workflows/hooks/useNodeSize'
import useEntryRules from 'Workflows/hooks/useEntryRules'

function StartNode({ data }) {
  const act = useAct()
  const ref = useNodeSize('start')
  const { entryRules, description, hasRules } = useEntryRules()
  const isSelected = useSel(s => s.local.sidebar?.kind === 'startNode')

  const allRootGroups = description || []
  const includeRoot = allRootGroups.find(g => !g.exclude)
  const rootType = includeRoot?.type || 'all'
  const groupCount = allRootGroups.reduce((sum, g) => sum + (g.rules || []).filter(r => typeof r === 'object' && r !== null).length, 0)
  const standaloneCount = allRootGroups.reduce((sum, g) => sum + (g.rules || []).filter(r => typeof r === 'string').length, 0)

  function onNodeClick() {
    act.local.setSidebar({ kind: 'startNode' })
  }

  function openEntryRules(e) {
    e.stopPropagation()
    act.local.editEntryRules()
  }

  return (
    <div
      className={`node base-node node-start${isSelected ? ' selected' : ''}`}
      ref={ref}
      onClick={onNodeClick}
    >
      <div className='node-header'>
        <div className='node-icon'>
          <div className='icon'>
            <SvgIconsEnter width={22} height={22} />
          </div>
        </div>
        <div className='node-text'>
          <p className='title'>Entry</p>
          <p className='subtitle'>Members enter the workflow when they match these rules.</p>
        </div>
      </div>

      {hasRules ? (
        <div className='entry-rules-strip populated' onClick={(e) => e.stopPropagation()}>
          <span className='strip-label'>Match {rootType}</span>
          <div className='rule-pills'>
            {groupCount > 0 && (
              <span className='rule-pill'>
                <SvgIconsFilterFunnel width={11} height={11} style={{ flexShrink: 0 }} />
                {groupCount} group{groupCount !== 1 ? 's' : ''}
              </span>
            )}
            {standaloneCount > 0 && (
              <span className='rule-pill'>
                <SvgIconsFilterFunnel width={11} height={11} style={{ flexShrink: 0 }} />
                {standaloneCount} rule{standaloneCount !== 1 ? 's' : ''}
              </span>
            )}
            {groupCount === 0 && standaloneCount === 0 && (
              <span className='rule-pill muted'>
                {entryRules.length - 1} condition{entryRules.length - 1 !== 1 ? 's' : ''}
              </span>
            )}
          </div>
          <button type='button' className='strip-edit' onClick={openEntryRules}>Edit</button>
        </div>
      ) : (
        <button type='button' className='entry-rules-strip empty' onClick={openEntryRules}>
          <SvgIconsFilterFunnel width={12} height={12} />
          <span>Set Entry Rules</span>
        </button>
      )}

      <Handle type="source" position={Position.Bottom} />
    </div>
  )
}

export default memo(StartNode)
